"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockOracleFactory = /** @class */ (function (_super) {
    __extends(MockOracleFactory, _super);
    function MockOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockOracleFactory;
}(contracts_1.ContractFactory));
exports.MockOracleFactory = MockOracleFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "CURRENT_PRICE",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "price",
                type: "tuple",
            },
        ],
        name: "setPrice",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60a0604052678ac7230489e80000608081905260005534801561002157600080fd5b506101f9806100316000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80630c15e407146100465780634b369a611461005b57806396a0e5e314610079575b600080fd5b61005961005436600461010d565b61008e565b005b610063610094565b6040516100709190610167565b60405180910390f35b61008161009a565b6040516100709190610159565b51600055565b60005481565b6100a26100b6565b506040805160208101909152600054815290565b6040518060200160405280600081525090565b6000602082840312156100db57600080fd5b6100e56020610175565b905060006100f384846100fc565b82525092915050565b80356101078161019f565b92915050565b60006020828403121561011f57600080fd5b600061012b84846100c9565b949350505050565b80516020830190610144848261014a565b50505050565b6101538161019c565b82525050565b602081016101078284610133565b60208101610107828461014a565b60405181810167ffffffffffffffff8111828210171561019457600080fd5b604052919050565b90565b6101a88161019c565b81146101b357600080fd5b5056fea365627a7a72315820e0628992ed2689f705cd8d5e637a099299649f50722f1b6ef5eba8990ccb26bc6c6578706572696d656e74616cf564736f6c63430005100040";
